module.exports = __webpack_public_path__ + "img/ico_youtube.2bdaee98.svg";